import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles/index';
import Grid from '@material-ui/core/Grid';
import { Card, CardContent } from "@material-ui/core";
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Icon from '@material-ui/core/Icon';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import DropzoneComponent from '../common/dropzone.component';
import { uploadFiles } from '../../api';
import { addMessage } from '../../store/actions/message.actions';


const styles = () => ({
  textField: {
    margin: ' 10px 0 0',
    width: '550px',
  },
  uploadbox: {
    display: 'inline-block',
  },
  header: {
    background: 'radial-gradient(at top, #49b2ed, #1183e6)',
    boxShadow: 'none',
    paddingTop: '3px',
    paddingBottom: '0px',
    paddingLeft: '20px'
  },
  white: {
    color: 'white',
    padding: '10px 0',
  },
  uploadBtn: {
    opacity: '1',
    bottom: ' 25px',
    right: '25px',
    position: 'fixed',
  },
  buttonProgress: {
    top: ' calc(50% - 14px)',
    left: 'calc(50% - 12.5px)',
    position: 'absolute',
  },
  icon: {
    color: '#9a9a9a',
    fontSize: '3rem',
  },
  height: {
    minHeight: '175px',
    boxShadow: 'none',
    backgroundColor: '#eaeaea',
  },
  pointer: {
    textAlign: 'center',
    padding: '67px 0  56px !important',
    '&:hover': {
      cursor: 'pointer'
    }
  }
});

class UploadContainer extends React.Component {
  constructor(props) {
    super(props);

    this.toggleDialog = this.toggleDialog.bind(this);
    this.onFileUpload = this.onFileUpload.bind(this);
    this.onTemplateUpload = this.onTemplateUpload.bind(this);
    this.onFileNameChange = this.onFileNameChange.bind(this);
    this.submitFile = this.submitFile.bind(this);

    this.state = {
      dialogOpen: false,
      isUploadingFile: false,
      files: [],
      fileNames: [],
      templateFile: '',
      templateFileName: '',
      name: '',
    };
  }

  async toggleDialog() {
    this.setState({
      dialogOpen: !this.state.dialogOpen,
      isUploadingFile: false,
      files: [],
      fileNames: [],
      templateFile: '',
      templateFileName: '',
      name: '',
    });
  }

  onFileUpload(files) {
    const newFiles = this.state.files;
    newFiles.push(...files);

    const newFileNames = newFiles.map(file => { return file.name });
    const newName = this.state.name ? this.state.name : newFiles[0].name;

    this.setState({
      files: newFiles,
      fileNames: newFileNames,
      name: newName,
    });
  }

  onTemplateUpload(file) {
    this.setState({
      templateFile: file[0],
      templateFileName: file[0].name,
    });
  }

  onFileNameChange(evt) {
    this.setState({ name: evt.target.value });
  }

  submitFile(event) {
    event.preventDefault();

    if (this.state.name.replace(/\s/g, '') === '') {
      this.props.addMessage('error', 'Project name can not be empty');
      return;
    }

    if (!this.state.files[0]) {
      this.props.addMessage('error', 'No files selected');
      return;
    }

    this.setState({ isUploadingFile: true });

    uploadFiles(this.state).then(() => {
      this.props.refreshSessions();
      this.props.addMessage('success', 'New project created');
    }).catch((e) => {
      console.error(e);
      this.props.addMessage('error', 'Something went wrong try again later');
    });
  }

  render() {
    const { dialogOpen } = this.state;
    const { classes } = this.props;

    return (

      <Grid item xs={12} md={6} lg={3}>
        <Card className={classes.height}>
          <CardContent className={classes.pointer} onClick={this.toggleDialog} >
            <Icon className={classes.icon} >
              add_circle
            </Icon>
          </CardContent>
        </Card>
        {dialogOpen ? this.renderDialog() : ''}
      </Grid>

    );

  }

  renderDialog() {
    const { dialogOpen, isUploadingFile, fileNames, templateFile, templateFileName } = this.state;
    const { classes } = this.props;

    return (
      <Dialog
        open={dialogOpen}
        onClose={this.toggleDialog}
      >
        <DialogTitle>Upload</DialogTitle>
        <DialogContent>
          <form onSubmit={this.submitFile}>
            <Grid container spacing={24}>
              <Grid item md={12}>
                <FormControl>
                  <TextField
                    autoFocus
                    label="Name"
                    className={classes.textField}
                    value={this.state.name}
                    onChange={this.onFileNameChange}
                  />
                </FormControl>
              </Grid>
              <Grid item md={6}>
                <DropzoneComponent
                  text={`Drop your files here`}
                  width="265"
                  disabled={isUploadingFile}
                  onFileChange={this.onFileUpload}
                />
              </Grid>
              <Grid item md={6}>
                <DropzoneComponent
                  text={`Drop your template here`}
                  width="265"
                  onFileChange={this.onTemplateUpload}
                />
              </Grid>
              <Grid item md={6}>
                <FormLabel>Files</FormLabel><br />
                {
                  !fileNames[0] ? <Typography variant="body2">No files selected</Typography> : fileNames.map((filename, index) => { return (<Typography key={index} variant="body2">{filename}</Typography>) })
                }
              </Grid>
              <Grid item md={6}>
                <FormLabel>Template File</FormLabel><br />
                <Typography variant="body2">
                  {
                    templateFile === '' ? 'No template selected' : templateFileName
                  }
                </Typography>
              </Grid>
            </Grid>
          </form>
        </DialogContent>
        <DialogActions>
          <Button disabled={isUploadingFile} onClick={this.toggleDialog} color="primary">
            Cancel
            </Button>
          <Button disabled={isUploadingFile} onClick={this.submitFile} color="primary">
            {isUploadingFile ? <span>Upload<CircularProgress size={25} className={classes.buttonProgress} color="secondary" /></span> : 'Upload'}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

UploadContainer.propTypes = {
  addMessage: PropTypes.func.isRequired,
  /* eslint-disable  */
  classes: PropTypes.object.isRequired,
  refreshSessions: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  /* eslint-enable */
};

export default withStyles(styles)(connect(null, { addMessage })(withRouter(UploadContainer)));
